var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OPASITY",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #OPASITY .cls-1,\n      #OPASITY .cls-2 {\n        fill: #f5f5f5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_140",
    "data-name": "Pfad 140",
    className: "cls-2",
    d: "M16,0A16,16,0,1,0,32,16,15.983,15.983,0,0,0,16,0Zm0,30A14,14,0,1,1,30,16,14.172,14.172,0,0,1,16,30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_141",
    "data-name": "Pfad 141",
    className: "cls-1",
    d: "M16,25a8.964,8.964,0,0,0,8.9-8.8v-.7a9.852,9.852,0,0,0-.2-1.7,1.421,1.421,0,0,0-.2-.6,7.838,7.838,0,0,0-.5-1.4.764.764,0,0,1-.2-.5,4.44,4.44,0,0,0-.8-1.1c-.1-.1-.2-.3-.3-.4a4.3,4.3,0,0,0-1-.9c-.1-.1-.3-.2-.4-.3a7.458,7.458,0,0,0-1.2-.7c-.2-.1-.3-.2-.5-.2A10.481,10.481,0,0,0,16,7m0,0h0a9,9,0,0,0,0,18h.1m7.8-9.4v.6h0v.3l-6.9,7V21.6l6.8-6.8A1.949,1.949,0,0,1,23.9,15.6Zm-.3-1.9a4.331,4.331,0,0,1,.1.5h0L17,20.9V19l6.2-6.2A1.884,1.884,0,0,1,23.6,13.7ZM22.9,12c0,.1.1.1.1.2l-6,6V16.3l5.2-5.2A5.5,5.5,0,0,1,22.9,12ZM21,9.8a6.47,6.47,0,0,0,.9.8v.1L17,15.6V13.7l4-3.9Zm-1.3-.9a2.361,2.361,0,0,1,.9.6L17,13V11.1l2.4-2.4C19.5,8.8,19.6,8.8,19.7,8.9ZM17,8a13.322,13.322,0,0,1,1.9.5L17,10.4Zm.3,15.9,6.5-6.5A8.093,8.093,0,0,1,17.3,23.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpacity);
export default __webpack_public_path__ + "static/media/opacity.a524fe3ee12e3917888e2c3c1b0c96d0.svg";
export { ForwardRef as ReactComponent };